import React from 'react'
import TruncatedTooltipLink from './TruncatedTooltipLink'

const Navigation = ({ data }) => {
  const previous = data.page_navigation?.page_previous
  const next = data.page_navigation?.page_next
  const hasPrevious = Boolean(previous?.uri)
  const hasNext = Boolean(next?.uri)

  if (!hasPrevious && !hasNext) {
    return null
  }

  return (
    <nav
      className={[
        'bottom-navigation',
        hasPrevious && hasNext ? 'bottom-navigation--paired' : null,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {hasPrevious ? (
        <TruncatedTooltipLink
          className="bottom-navigation__item"
          linkClassName="bottom-navigation__link bottom-navigation__link--previous"
          text={previous.title}
          href={previous.uri}
          component="a"
        />
      ) : null}
      {hasNext ? (
        <TruncatedTooltipLink
          className="bottom-navigation__item"
          linkClassName="bottom-navigation__link bottom-navigation__link--next"
          text={next.title}
          href={next.uri}
          component="a"
        />
      ) : null}
    </nav>
  )
}

export default Navigation
